import { connect } from 'react-redux';
import actions from 'actions';
import ManageAI from "../Pages/ManageAI/ManageAI";
import {createApolloClient} from "../Helpers/ApolloClientHelpers";

const mapStateToProps = (state) => {
  return {
    user:state.current && state.current.user,
    client:createApolloClient(),
    company:state.company && state.company.company
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    addAI:(aId, aName, aKeyword, aDescription) => {
      return dispatch(actions.addAI(aId, aName, aKeyword, aDescription));
    },
    fetchAI:(aId) => {
      return dispatch(actions.fetchAI(aId));
    },
    fetchAIs:(aLimit, aOffset, aSearchString) => {
      return dispatch(actions.fetchAIs(aLimit, aOffset, aSearchString));
    },
    removeAI:(aId) => {
      return dispatch(actions.removeAI(aId));
    },
    addAIMessage:(aKeyword, aMessage, aPatientId, aFile, aClient) => {
      return dispatch(actions.addAIMessage(aKeyword, aMessage, aPatientId, aFile, aClient));
    },
    addAIDocument:(aId, aAiId, aName, aFile, aClient) => {
      return dispatch(actions.addAIDocument(aId, aAiId, aName, aFile, aClient));
    },
    fetchAIMessages:(aKeyword, aPatientId, aLimit, aOffset, aSearchString) => {
      return dispatch(actions.fetchAIMessages(aKeyword, aPatientId, aLimit, aOffset, aSearchString));
    },
    removeAIDocument:(aId) => {
      return dispatch(actions.removeAIDocument(aId));
    },
    fetchAIDocuments:(aId, aLimit, aOffset, aSearchString) => {
      return dispatch(actions.fetchAIDocuments(aId, aLimit, aOffset, aSearchString));
    }
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(ManageAI)
